import {
  shiftTimeDisplayValues,
  type IScheduledShift,
} from "@medoma/models/shifts";
import { Text, type IText } from "@medoma/components/Text/Text";
import { useLingui } from "@lingui/react/macro";
import styles from "./ShiftTime.module.scss";
import { useSelectedDate } from "@/Utils/useSelectedDate";
import clsx from "clsx";
import { TimeSpan } from "./TimeSpan";

type IShiftTime = Pick<IScheduledShift, "startDateTime" | "endDateTime"> &
  Pick<IText, "size" | "color" | "weight"> & {
    layout?: "horizontal" | "vertical";
  };

const ShiftTime = ({
  startDateTime,
  endDateTime,
  size = "base",
  color,
  layout = "vertical",
  weight,
}: IShiftTime) => {
  const { t } = useLingui();
  const selectedDate = useSelectedDate();

  const {
    startedDayBefore,
    hasEndTimeAfterToday,
    formattedDayBefore,
    formattedDayToday,
  } = shiftTimeDisplayValues({
    selectedDate,
    startDateTime,
    endDateTime,
  });

  const additionalContext = `${startedDayBefore ? t`Start ${formattedDayBefore}` : hasEndTimeAfterToday ? t`Start ${formattedDayToday}` : ""}`;
  const hasAdditionalContext = additionalContext !== "";

  return (
    <>
      <div className={clsx([styles.shiftTime, styles[`layout-${layout}`]])}>
        <TimeSpan
          timespan={{ start: startDateTime, end: endDateTime }}
          size={size}
          color={color}
          weight={weight}
        />
        {hasAdditionalContext ? (
          <Text
            element="div"
            color="faded"
            size={layout === "vertical" ? "small" : size}
            weight={weight}
          >
            {additionalContext}
          </Text>
        ) : null}
      </div>
    </>
  );
};

export { ShiftTime };
